import { AFFILIATE } from './constants'

const COOKIE_NAME = 'affiliate_ref'

export function getAffiliateCookie(): string | null {
  const cookies = document.cookie.split(';')
  const affiliateCookie = cookies.find((cookie) =>
    cookie.trim().startsWith(`${COOKIE_NAME}=`)
  )

  if (!affiliateCookie) return null

  return affiliateCookie.split('=')[1].trim()
}

export function setAffiliateCookie(code: string): void {
  const expirationDate = new Date()
  expirationDate.setDate(expirationDate.getDate() + AFFILIATE.COOKIE_DURATION)

  document.cookie = `${COOKIE_NAME}=${code}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`
}

export function clearAffiliateCookie(): void {
  document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
}

